export const MOYU_PROMO_SURFACES = [
  'blog_post_end',
  'blog_index',
  'story_library',
  'best_apps_editorial'
] as const

export type MoyuPromoSurface = (typeof MOYU_PROMO_SURFACES)[number]
export type MoyuPromoVariant = 'full' | 'strip'

const MOYU_LOCALES = new Set([
  'en',
  'es',
  'de',
  'fr',
  'vi',
  'id',
  'ja',
  'ko',
  'th'
])

export function getMoyuLocale(locale: string): string {
  return MOYU_LOCALES.has(locale) ? locale : 'en'
}

export function buildMoyuPromoUrl(
  locale: string,
  surface: MoyuPromoSurface
): string {
  const url = new URL(`https://moyuchinese.com/${getMoyuLocale(locale)}`)
  url.searchParams.set('utm_source', 'miaozi')
  url.searchParams.set('utm_medium', 'referral')
  url.searchParams.set('utm_campaign', 'moyu_launch')
  url.searchParams.set('utm_content', surface)
  return url.toString()
}

export function buildMoyuAnalyticsPayload({
  variant,
  surface,
  locale,
  pagePath
}: {
  variant: MoyuPromoVariant
  surface: MoyuPromoSurface
  locale: string
  pagePath: string
}) {
  return {
    variant,
    surface,
    locale,
    page_path: pagePath
  }
}
